<div class="host-add-label-picker">
  <div class="selected-items flex flex-row flex-wrap">
    <div 
      class="selected-item group px-[7px] py-[0]" 
      [style.background-color]="item.color"
      *ngFor="let item of selectedLabels">
      <span class="label">{{ item.label }}</span>
      <div 
        class="delete absolute -top-[7px] -right-[7px] w-[14px] h-[14px] cursor-pointer rounded-full hidden group-hover:block"
        [style.background-color]="item.color" 
        (click)="onCancelCheck(item)">
        <img class="w-full h-full" src="/assets/status/cancel-label.png" alt="">
      </div>
    </div>
    <div 
      class="picker flex flex-row items-center h-[24px] leading-none bg-[#ebebeb] text-[12px] text-[#a2a2a2] whitespace-nowrap rounded-[2px] py-[0] px-[7px] cursor-pointer"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="menu"
      [(nzVisible)]="visible"
      nzOverlayClassName="add-label-picker-dropdown">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
      <span>{{ 'order.add_tag' | translate }}</span>
    </div>
  </div>
</div>
<nz-dropdown-menu #menu>
  <div class="label-panel ant-dropdown-menu w-[430px]">
    <div class="content flex flex-row flex-wrap px-[12px] py-[8px]">
      <ng-container 
        *ngFor="let label of listOfLabel; trackBy: trackById">
        <div class="label px-[2px] py-[0]" [style.background-color]="label.color">
          <label 
            nz-checkbox 
            [nzId]="label.value"
            [(ngModel)]="label.checked" 
            (ngModelChange)="onCheckChange($event)">{{ label.label }}</label>
        </div>
      </ng-container>
    </div>
    <div class="footer flex flex-row items-center justify-between p-[12px] pb-[8px] border-t border-solid border-t-[#eee]">
      <a routerLink="/app/settings/options" [queryParams]="{ index: 1 }" class="link">
        <img class="w-[16px] h-[16px]" src="/assets/icon/manage_tag.png" />
            <!-- 标签管理 -->
        <span class="text-primary text-[14px] pl-[5px]">{{ 'order.manage_tag' | translate }}</span>
      </a>

      <button nz-button nzType="primary" (click)="onClose()">{{ 'word.close' | translate }}</button>
    </div>
  </div>
</nz-dropdown-menu>
